<template>
  <my-modal v-if="!isEdit" no-container>
    <div class="form-wrapper">
      <profile-delete-counter v-if="isLoaded" />
      <div class="my-modal__content">
        <form v-if="!sendSuccess" class="form" @submit.prevent="submit">
          <profile-tabs />
          <div class="form-row form-row_2-cols form-row_mobile-no-flex">
            <div>
              <text-input
                  v-if="$route.name !== 'profile-fields' || !profile.lastName"
                  label="Фамилия"
                  v-model="profile.lastName"
                  name="lastName"
                  disabled
              />
              <text-input
                  v-if="$route.name !== 'profile-fields' || !profile.firstName"
                  label="Имя"
                  v-model="profile.firstName"
                  name="firstName"
                  disabled
              />
              <text-input
                  v-if="$route.name !== 'profile-fields' || !profile.middleName"
                  label="Отчество"
                  v-model="profile.middleName"
                  name="middleName"
                  disabled
              />
            </div>
            <div>
              <text-input
                  v-if="$route.name !== 'profile-fields' || !profile.birthDate"
                  label="Дата рождения"
                  :value="profile.birthDate | dateFilter"
                  name="birthDate"
                  append-classes="_date"
                  disabled
              />
              <div v-if="$route.name !== 'profile-fields' || !profile.sex" class="form-group">
                Пол
                <radio-input
                    label="Мужской"
                    value="male"
                    name="sex"
                    v-model="profile.sex"
                    disabled
                />
                <radio-input
                    label="Женский"
                    value="female"
                    name="sex"
                    v-model="profile.sex"
                    disabled
                />
              </div>
            </div>
          </div>
          <h2 class="form__subtitle _align-left">Контактные данные</h2>
          <div class="form-row form-row_2-cols _alt form-row_mobile-no-flex">
            <div>
              <text-input
                  label="Электронная почта"
                  v-model="emailToUnicode"
                  name="email"
                  disabled
              />
              <div v-if="!profileData.isEmailConfirmed" class="pending-label">Ожидает подтверждения</div>
            </div>

            <div>
              <button
                  class="form__submit button button__md button__blue"
                  type="button"
                  @click="changeCredentials('email')"
              >Редактировать</button>
            </div>
          </div>

          <div class="form-row form-row_2-cols _alt form-row_mobile-no-flex">
            <div>
              <text-input
                  label="Телефон"
                  type="tel"
                  :value="String(profile.mobilePhone).slice(1)"
                  name="mobilePhone"
                  disabled
              />
              <div v-if="!profileData.isMobilePhoneConfirmed" class="pending-label">Ожидает подтверждения</div>
            </div>
            <div>
              <button
                  class="form__submit button button__md button__blue"
                  type="button"
                  @click="changeCredentials('phone')"
              >Редактировать</button>
            </div>
          </div>

          <div class="form-row form-row_2-cols _alt form-row_mobile-no-flex">
            <text-input
                label="Регион"
                name="customer-region"
                v-model="address.customerRegion"
                disabled
            />
            <div>
              <button
                  class="form__submit button button__md button__blue"
                  type="button"
                  @click="changeCredentials('address')"
              >Редактировать</button>
            </div>
          </div>

          <h2 class="form__subtitle _align-left">ОПРОСНИК ПО ТАБАЧНЫМ ПРЕДПОЧТЕНИЯМ</h2>
          <div class="form-row form-row_2-cols form-row_mobile-no-flex _g-items-flex-end">
            <div>
              <div class="form-row__description">Как давно Вы&nbsp;курите?</div>
              <text-input
                  label="Период"
                  :value="primaryBrandAgeField"
                  name="primaryBrandAgeField"
                  tabindex="5"
                  disabled
              ></text-input>
            </div>
            <div>
              <div class="form-row__description">Сколько сигарет Вы выкуриваете в&nbsp;день?</div>
              <text-input
                  label="Количество"
                  :value="profileData.customFields.cigaretteCountPerDayField"
                  name="cigaretteCountPerDayField"
                  tabindex="5"
                  disabled
              ></text-input>
            </div>
          </div>
          <div v-if="getSubfamilyItemName(profileData.customFields.primarySubfamily)"
               class="form-row form-row_2-cols form-row_mobile-no-flex _g-items-flex-end"
          >
            <div>
              <div class="form-row__description">Какую марку сигарет Вы покупали и&nbsp;курили чаще всего в&nbsp;течение последних 4-х недель?</div>
              <text-input
                  label="Марка сигарет"
                  :value="getSubfamilyItemName(profileData.customFields.primarySubfamily)"
                  name="primarySubfamily"
                  tabindex="5"
                  disabled
              ></text-input>
            </div>
            <div>
              <div class="form-row__description">Из последних десяти пачек, сколько составили пачки этой марки?</div>
              <text-input
                  label="Количество"
                  :value="profileData.customFields.primaryBrandShareField"
                  name="primaryBrandShareField"
                  tabindex="5"
                  disabled
              ></text-input>
            </div>
          </div>
          <div v-if="getSubfamilyItemName(profileData.customFields.secondarySubfamily)"
               class="form-row form-row_2-cols form-row_mobile-no-flex _g-items-flex-end"
          >
            <div>
              <div class="form-row__description">Какую марку сигарет Вы&nbsp;купите, если Вашей основной марки нет в&nbsp;продаже?</div>
              <text-input
                  label="Марка сигарет"
                  :value="getSubfamilyItemName(profileData.customFields.secondarySubfamily)"
                  name="primarySubfamily"
                  tabindex="5"
                  disabled
              ></text-input>
            </div>
          </div>
          <div v-if="deletionDate" class="form-row form-row_align-center-on-desktop form-row_wrap ">
            <div class="form-row__description form-row__description_no-margins">
              Ваша анкета и данные будут удалены через <b>{{ deletionDate | remainingDays }}</b>
            </div>
          </div>
          <div class="form-row form-row_align-center-on-desktop form-row_wrap ">
            <div class="form-row__description form-row__description_no-margins">
              <router-link
                  :to="{ path: (this.$route.name === 'profile-fields' ? '/register' : '') + '/consumption-survey' }"
                  class="form__link">Внести</router-link> изменения в опросник по табачным предпочтениям</div>
          </div>
          <!--div class="form-row form-row_align-center form-row_mobile-wrap">
            <button class="form__submit button button__lg button__blue" type="submit">Сохранить</button>
          </div-->

          <div class="form-row form-row_links ">
            <!--<div class="form-row__description form-row__description_no-margins">
              <router-link
                :to="{ name: 'profile-password' }"
                class="form__link"
              >
                Сменить пароль
              </router-link>
            </div>-->
            <div class="form-row__description form-row__description_no-margins">
              <router-link
                :to="{ name: 'profile-delete' }"
                class="form__link"
              >
                Управлять анкетой
              </router-link>
            </div>
          </div>

        </form>
        <div v-else>
          <div class="form-row form-row_align-center">
            <p>Обновлённая информация сохранена</p>
          </div>
          <div class="form-row form-row_align-center">
            <button type="button" class="button button__blue button__lg" @click.prevent="returnToProfile2">
              Назад
            </button>
          </div>
        </div>
      </div>
    </div>
  </my-modal>
  <my-modal v-else>
    <profile-credentials-change :changeType="changeType" :profile="profileData" @returnToProfile="returnToProfile"/>
  </my-modal>
</template>

<script>
import MyModal from "../MyModal";
import TextInput from "../TextInput";
import {required, email} from "vuelidate/lib/validators";
import api from "../../services/api";
import ProfileCredentialsChange from "./ProfileCredentialsChange";
// import SignInput from '../SignInput';
import {toUnicode} from "../../utils";
import ProfileDeleteCounter from "./ProfileDeleteCounter.vue";
//import invisibleCaptcha from "../../mixins/invisibleCaptcha";

export default {
  name: "ProfileForm",
  //mixins: [invisibleCaptcha],
  components: {ProfileDeleteCounter, ProfileCredentialsChange, TextInput, MyModal},
  data() {
    return {
      profile: {
        lastName: '',
        firstName: '',
        middleName: '',
        birthDate: '',
        sex: '',
        email: '',
        mobilePhone: '',
        personalDataAgreementSignature: '',
      },
      address: {
        fiasId: '',
        customerRegion: '',
      },
      isLoaded: false,
      isEdit: false,
      changeType: null,
      sendSuccess: false,
      primaryBrandAgeField: '',
      smokePeriodOptions: {
        'lessThan3Months': 'До 3 месяцев',
        '3to6Months':'3-6 месяцев',
        '6to12Months': '6-12 месяцев',
        'moreThanAYear': 'Больше года'
      }
    }
  },
  validations: {
    profile: {
      email: {required, email},
      mobilePhone: {required},
    },
    address: {
      fiasId: {required},
      customerRegion: {required},
    },
  },
  computed: {
    dadataToken() {
      return '44f7453167d491b6b74dec9c95bc71f66de244cf';
    },
    profileData() {
      return this.$route.params && this.$route.params.email
        ? { ...this.$store.state.currentUser, email: this.$route.params.email }
        : this.$store.state.currentUser;
    },
    cigaretteMarks() {
      return this.$store.state.cigaretteMarks || [];
    },
    emailToUnicode() {
      return toUnicode(this.profile.email);
    },
    deletionDate() {
      return this.$store.getters.deletionDate
    }
  },
  async mounted() {
    await this.updateProfileData();
    this.isLoaded = true;

    if (this.$route.params && this.$route.params.email) {
      this.isEdit = true
      this.changeType = 'email'
    }
  },
  methods: {
    async submit() {
      // implementing invisible captcha
      // await this.updateCaptchaOnSubmit();

      this.$v.$touch();
      if ((!this.$v.$pending && !this.$v.$invalid)) {
        try {
          this.$store.dispatch("showLoader");
          const result = await api.simplePostSuccess('/api/updateMindboxUserFields', {
            ...this.profile,
            ...this.address
          });
          if (result) {
            if (this.$route.name === 'profile-fields') {
              await this.$store.dispatch('checkAuthentication');
              await this.$store.dispatch('segmentsJump');
            } else {
              this.$v.$reset();
              await this.$store.dispatch('fetchProfile');
              await this.updateProfileData();
            }
            this.sendSuccess = true;
          }
        } catch (e) {
          this.$store.dispatch('setErrors', e);
        } finally {
          this.$store.dispatch("hideLoader");
        }
      }
    },
    changeCredentials(type) {
      this.isEdit = true;
      this.changeType = type;
    },
    async returnToProfile() {
      await this.$store.dispatch('fetchProfile');
      await this.updateProfileData();
      this.isEdit = false;
      this.changeType = null;
    },
    async returnToProfile2() {
      this.sendSuccess = false;
      this.isLoaded = false;
      await this.updateProfileData();
      this.isLoaded = true;
    },
    getSubfamilyItemName(subfamily) {
      let name = ''

      if (subfamily) {
        this.cigaretteMarks.some(item => {
          if (typeof item.subfamilies !== 'undefined') {
            name = item.subfamilies.find(subItem => subItem.spicId === subfamily)?.name || ''
            return !!name
          }
          return false;
        });
      }

      return name
    },
    async updateProfileData() {
      Object.keys(this.profile).forEach(key => this.profile[key] = this.profileData[key] || '');
      Object.keys(this.address).forEach(key => this.address[key] = this.profileData.customFields[key] || '');
      this.profile.personalDataAgreementSignature = this.profileData.customFields.personalDataAgreementSignature || '';

      if (this.profileData.customFields.primarySubfamily || this.profileData.customFields.secondarySubfamily) {
        await this.$store.dispatch('fetchCigaretteMarks');
      }

      this.primaryBrandAgeField = this.profileData.customFields.primaryBrandAgeField ? this.smokePeriodOptions[this.profileData.customFields.primaryBrandAgeField] : '';
      if (!this.profileData.isEmailConfirmed && this.profileData.pendingEmail) {
        this.profile.email = this.profileData.pendingEmail;
      }
      if (!this.profileData.isMobilePhoneConfirmed && this.profileData.pendingMobilePhone) {
        this.profile.mobilePhone = this.profileData.pendingMobilePhone;
      }
      if (this.profileData.area?.ids?.externalId) {
        this.address.customerRegion = await api.findAddress(this.dadataToken, this.profileData.area.ids.externalId, 'region_with_type');
        this.profileData.customFields.customerRegion = this.address.customerRegion;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../scss/base/_settings.scss";
  .form-wrapper {
    gap: 20px;
    display: flex;
    flex-direction: column;
    position: relative;
  }

  .form-row {
    > div {
      &:not(:last-child) {
        @include mobile {
          margin-bottom: 16px;
        }
      }
    }
    &_footnote {
      margin-top: -16px;
    }
    &_2-cols {
      &._alt {
        > * {
          @include mobile-min {
            &:first-child {
              width: calc(60% - 10px);
            }
            &:last-child {
              width: calc(40% - 10px);
            }
          }
        }
      }
    }
    &__description {
      &_no-margins {
        .form-row.form-row & { // increasing specificity, needs refactoring
          margin-bottom: 0;
        }
      }
    }
  }
  .text-input {
    &:not(:last-child) {
      margin-bottom: 16px;
    }
  }
  .pending-label {
    margin-top: -15px;
  }
</style>
